import { render, staticRenderFns } from "./tabZujianChild1.vue?vue&type=template&id=8591b6a0&scoped=true&"
import script from "./tabZujianChild1.vue?vue&type=script&lang=js&"
export * from "./tabZujianChild1.vue?vue&type=script&lang=js&"
import style0 from "./tabZujianChild1.vue?vue&type=style&index=0&id=8591b6a0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8591b6a0",
  null
  
)

export default component.exports